import React, { Component, createRef } from "react";
import axios from 'axios';
import { Button, Select, Tab, Tabs, Grid, MenuItem, IconButton, SelectChangeEvent, Snackbar, Box, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, Alert, Autocomplete, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { baseUrl, decodeJwt, rolenum, UserRole } from '../Pages/ApiCommonService';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { fetchAllLobs, createIdForFileUploaded, createJobidForAfterFileUpload, fetchAllChecklistType } from '../ApiSevices/FileUploadApis';
import { GridTable1 } from "../Sidebar/SidebarStyles";
import { expTokenProcessAndGenerate } from "../ApiSevices/AuthApis";
import { fetchBrokerFileUploadLImit } from "../ApiSevices/ExdionAdminApi";
import { fetchCSRUsersByBroker, GetAllCsrUserConfig, GetMarshalBrokerConfig } from "../ApiSevices/UserMasterApis";

interface UploadedFile {
    name: any;
    file: File;
    docType: string;
}

interface TableProps {
    displaysidebar: boolean;
    normalUpload?: boolean;
    basePath?: string;
    isMSUser?: boolean;
    selectedBrokerId?: number;
    selectedCSRUserId?: number;
    selectedCSRUser?: string;
    selectedSecondaryCSRUserId?: number;
    complianceFlag?: number;
}

interface CSR {
    ID: number,
    vchEmail: string;
}

interface State {
    jobId: any;
    JobId: any;
    successfullyUploadedFields: any;
    successfullyUploadedDocs: any;
    lockedFieldsMessage: any;
    activeTab: "AutomaticRenewal" | "MarketedRenewal";
    uploadedFiles: {
        AutomaticRenewal: { [key: string]: UploadedFile[] };
        MarketedRenewal: { [key: string]: UploadedFile[] };
    };
    selectedCoverage: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    selectedPrimaryUser: {
        AutomaticRenewal: number;
        MarketedRenewal: number;
    };
    selectedSecondaryUser: {
        AutomaticRenewal: number;
        MarketedRenewal: number;
    };
    lobCodes: { Lob_Name: string; Lob_Code: string }[];
    checklistTypes: { ID: string; VCH_CHECKLIST: string }[];
    selectedChecklist: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    remarks: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    clientName: {
        AutomaticRenewal: string;
        MarketedRenewal: string;
    };
    errors: {
        [key: string]: {
            lineOfCoverage: string;
            checklist: string;
            currentTermPolicy: string;
            priorTermPolicy: string;
            duplicateFiles: string;
            sourceDoc: string;
            primaryUser: string;
            secondaryUser: string;
        }
    };
    corruptedFiles: any;
    emptyFiles: any;
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: any;
    loading: boolean;
    isMandatory: boolean;
    mandatoryMessage: string;
    Role_Id: any;
    lobLoading?: boolean;
    checklistLoading?: boolean;
    MarshalBrokerMapping: any;
    showPrimaryUser: boolean;
    csrs: CSR[];

}

const validateFileUpload = (fieldName: string, file: File, activeTab: string, existingFiles: UploadedFile[]) => {
    const pdfOnlyFields = ["Current Term Policy", "Prior Term Policy", "Current Endorsement", "Prior Endorsement"]
    const PEW_FilesOnly = ["Proposal"]                  // Pdf, Excel & Word Only
    const PW_FilesOnly = ["Carrier Quote", "Binder"]    // Pdf, Word Only
    const PE_FilesOnly = ["Acord Application", "Schedule"]  // Pdf, Excel Only

    let allowedFormats: string[] | undefined;
    const extentionNameMap: Record<string, string> = {
        pdf: "PDF",
        doc: "Word",
        docx: "Word",
        xlsx: 'Excel',
        xls: 'Excel',
        json: "JSON"
    }

    if (fieldName === "Acord Application") {
        // Allow Word, PDF, and Excel for Acord Application
        allowedFormats = ["pdf", "xlsx", "xls", "doc", "docx",];
    } else if (PEW_FilesOnly?.includes(fieldName)) {
        allowedFormats = ["pdf", "doc", "docx", "xlsx", "xls"];
    } else if (pdfOnlyFields?.includes(fieldName)) {
        allowedFormats = ["pdf"];
    } else if (PW_FilesOnly?.includes(fieldName)) {
        allowedFormats = ["pdf", "doc", "docx"];
    } else if (PE_FilesOnly?.includes(fieldName)) {
        allowedFormats = ["pdf", "xlsx", "xls"];
    }

    const fileExtension = file?.name?.split(".").pop()?.toLowerCase();
    if (!fileExtension || !allowedFormats?.includes(fileExtension)) {
        const namesSet = new Set<string>();

        for (const exe of allowedFormats ?? []) {
            const name = extentionNameMap[exe];
            if (name) namesSet.add(name)
        }

        const typeNames = Array.from(namesSet);
        const last = typeNames.pop();
        const readable = typeNames.length
            ? `${typeNames.join(", ")} and ${last}`
            : last;

        return `Only ${readable} files are allowed`;
    }

    // Enforce single file restriction for specific fields
    const singleFileFields = ["Current Term Policy", "Prior Term Policy"];
    if (singleFileFields?.includes(fieldName) && existingFiles?.length > 0) {
        return `${fieldName} allows only a single file`;
    }

    if (activeTab === "MarketedRenewal") {
        const multipleFormatFields = ["Proposal", "Acord Application", "Carrier Quote", "Binder"];
        if (multipleFormatFields?.includes(fieldName) && existingFiles.length > 0) {
            return `${fieldName} allows only a single file`;
        }
    }

    // // Handle maximum file uploads validation
    // const maxFileValidation = ["Current Endorsement", "Prior Endorsement"];
    // if (maxFileValidation?.includes(fieldName) && existingFiles?.length >= 4) {
    //     return `${fieldName} allows maximum count 4 for upload`;
    // }
    return null;
};
class RenewalForm extends Component<TableProps, State> {
    private fileInputRefs: Record<string, React.RefObject<HTMLInputElement>>;
    docTypeArray: Record<string, number> = { "Current Term Policy": 1, "Prior Term Policy": 2, "Current Endorsement": 3, "Prior Endorsement": 4, "Acord Application": 5, "Carrier Quote": 6, "Proposal": 7, "Schedule": 8, "Binder": 9 }

    constructor(props: TableProps) {
        super(props);
        this.state = {
            jobId: null,
            JobId: null,
            successfullyUploadedFields: {},
            successfullyUploadedDocs: {},
            lockedFieldsMessage: '',
            activeTab: "AutomaticRenewal",
            uploadedFiles: {
                AutomaticRenewal: {},
                MarketedRenewal: {},
            },
            selectedCoverage: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            lobCodes: [],
            checklistTypes: [],
            selectedPrimaryUser: {
                AutomaticRenewal: 0,
                MarketedRenewal: 0
            },
            selectedSecondaryUser: {
                AutomaticRenewal: 0,
                MarketedRenewal: 0
            },
            selectedChecklist: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            remarks: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            clientName: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            errors: {
                AutomaticRenewal: {
                    lineOfCoverage: "",
                    checklist: "",
                    currentTermPolicy: "",
                    priorTermPolicy: "",
                    duplicateFiles: "",
                    sourceDoc: "",
                    primaryUser: "",
                    secondaryUser: ""
                },
                MarketedRenewal: {
                    lineOfCoverage: "",
                    checklist: "",
                    currentTermPolicy: "",
                    priorTermPolicy: "",
                    duplicateFiles: "",
                    sourceDoc: "",
                    primaryUser: "",
                    secondaryUser: ""
                }
            },
            corruptedFiles: {},
            emptyFiles: {},
            snackbarOpen: false,
            snackbarMessage: "",
            snackbarSeverity: "error",
            loading: false,
            isMandatory: false,
            mandatoryMessage: "",
            Role_Id: '',
            lobLoading: false,
            checklistLoading: false,
            MarshalBrokerMapping: {},
            showPrimaryUser: false,
            csrs: []
        };
        this.fileInputRefs = {};
    }

    async componentDidMount() {
        // this.fetchLobs();
        // this.fetchAllChecklistType();
        try {
            this.setState({ loading: true });

            const token = sessionStorage.getItem('token');
            let brokerId;
            let roleId;
            let emailId;
            if (token) {
                const decodedToken = decodeJwt(token);
                roleId = decodedToken.RoleId;
                brokerId = decodedToken.BrokerId;
                emailId = decodedToken.Email;
                if (decodedToken) {
                    this.setState({ Role_Id: decodedToken.RoleId });
                } else {
                    console.warn("Token decoding failed or returned null");
                }
            }
            await Promise.all([this.fetchLobs(), this.fetchAllChecklistTypes(), this.fetchMarshalMapping(), this.fetchUsers(brokerId, roleId, emailId)]);
        } catch (error) {
            console.error('Error in component rendering:', error);
        } finally {
            this.setState({ loading: false });
        }
    }

    async fetchUsers(brokerId: number, roleId: number, userName?: string) {
        try {
            let response = await GetAllCsrUserConfig();
            const borkerIds = response?.data.filter((e: any) => e.IsActive).map((e: any) => e.BrokerId) || [];
            // const UserNames = response?.data.filter((e: any) => e.IsActive).map((e: any) => e.UserName).flat() || [];
            if (borkerIds.includes(brokerId) && (roleId === rolenum.BrokerAdmin || roleId === rolenum.CSR)) {
                const csrUsers = await fetchCSRUsersByBroker(brokerId);
                this.setState({ csrs: csrUsers || [], showPrimaryUser: true });
            }
        } catch (err) {
            console.error('Error fetching CSR users', err);
            this.setState({ loading: false, snackbarMessage: 'Error loading CSR users', snackbarSeverity: 'error', snackbarOpen: true });
        }
    }

    fetchLobs = async () => {
        try {
            const fetchResponse = await fetchAllLobs();

            if (fetchResponse && fetchResponse.length > 0) {
                const isPersonalLine = window.location.pathname
                    .toLowerCase()
                    .includes("/personalline/");

                const filteredLobs = fetchResponse.filter((item: any) => {
                    const lobName =
                        item?.Lob_Name?.trim().toLowerCase() || "";

                    const isPersonalCoverage =
                        lobName.startsWith("personal") ||
                        lobName === "homeowners";

                    if (isPersonalLine) {
                        return isPersonalCoverage;
                    }

                    return !isPersonalCoverage;
                });

                this.setState({
                    lobCodes: filteredLobs
                });
            }
        } catch (error) {
            console.error("Error fetching LOB data:", error);
        }
    };

    fetchAllChecklistTypes = async () => {
        try {
            // this.setState({ checklistLoading: true });
            const fetchResponse = await fetchAllChecklistType();
            if (fetchResponse && fetchResponse.length > 0) {
                const checklistTypes = fetchResponse as { ID: string; VCH_CHECKLIST: string }[];
                const defaultChecklist = checklistTypes.find(
                    item => item.VCH_CHECKLIST === "ExdionPOD STD"
                );

                this.setState((prevState) => ({
                    checklistTypes,
                    selectedChecklist: {
                        ...prevState.selectedChecklist,
                        [prevState.activeTab]: defaultChecklist
                            ? defaultChecklist.VCH_CHECKLIST
                            : prevState.selectedChecklist[prevState.activeTab] || "",
                    },
                }));
            }
        } catch (error) {
            console.error('Error fetching ChecklistTypes:', error);
        }
        // finally {
        //     this.setState({ checklistLoading: false });
        // }
    };

    fetchMarshalMapping = async () => {
        try {
            const response = await GetMarshalBrokerConfig();
            if (response) {
                this.setState({ MarshalBrokerMapping: response });
            } else {
                this.setState({ MarshalBrokerMapping: {} });
            }
        } catch (error) {
            console.error('Error fetching ChecklistTypes:', error);
        }
    }

    handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        this.setState({ activeTab: newValue as "AutomaticRenewal" | "MarketedRenewal" });
    };

    handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
        const { files } = e.target;
        const { activeTab, uploadedFiles, corruptedFiles } = this.state;
        // const maxSize = 80 * 1024 * 1024; // 80MB
        if (!files) return;

        if (files && files.length > 0) {
            let newFiles: UploadedFile[] = [];

            // Get existing files for multi-file support
            const existingFiles: UploadedFile[] = (uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];

            // Upload dependency validation
            const currentFiles = uploadedFiles[activeTab];

            // Restriction: Endorsements require respective Policy uploads
            if (fieldName === "Current Endorsement" && !currentFiles["Current Term Policy"]) {
                this.setState({
                    isMandatory: true,
                    mandatoryMessage: "To upload Current Term Endorsement, upload Current Term Policy.",
                });
                e.target.value = "";
                return;
            }

            if (fieldName === "Prior Endorsement" && !currentFiles["Prior Term Policy"]) {
                this.setState({
                    isMandatory: true,
                    mandatoryMessage: "To upload Prior Term Endorsement, upload Prior Term Policy.",
                });
                e.target.value = "";
                return;
            }

            if (fieldName === "Prior Term Policy" && !currentFiles["Current Term Policy"]) {
                this.setState({
                    isMandatory: true,
                    mandatoryMessage: "To upload Prior Term Policy you need to upload Current Term Policy.",
                });
                e.target.value = "";
                return;
            }


            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                // if (file && file?.size > maxSize) {
                //     alert("File size must be less than 80MB.");
                //     e.target.value = "";
                //     return false
                // }

                const sameFieldFileNameCheck = existingFiles?.some(item => item?.name === file?.name);
                if (sameFieldFileNameCheck) {
                    alert(`This file has already been selected:\n ${file?.name}`);
                    e.target.value = '';
                    return false;
                }

                const errorMessage = validateFileUpload(fieldName, file, activeTab, existingFiles);

                if (errorMessage) {
                    this.setState(
                        { snackbarOpen: true, snackbarMessage: errorMessage },
                        () => console.error("Snackbar triggered with message:", errorMessage)
                    );
                    e.target.value = "";
                    return;
                }

                const docType = String(this.docTypeArray[fieldName] || "");
                newFiles.push({ name: file.name, file, docType });
            }

            if (newFiles.length > 0) {
                this.setState((prevState) => {
                    const prevFiles: UploadedFile[] = (prevState.uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];

                    return {
                        uploadedFiles: {
                            ...prevState.uploadedFiles,
                            [activeTab]: {
                                ...prevState.uploadedFiles[activeTab],
                                [fieldName]: fieldName === "Current Term Policy" || fieldName === "Prior Term Policy"
                                    ? newFiles  // Replace for single-file fields
                                    : [...prevFiles, ...newFiles],  // Append for multi-file fields
                            },
                        },

                        errors: {
                            ...prevState.errors,
                            [activeTab]: {
                                ...prevState.errors[activeTab],
                                currentTermPolicy: fieldName === "Current Term Policy" ? "" : prevState.errors[activeTab]?.currentTermPolicy,
                                priorTermPolicy: fieldName === "Prior Term Policy" ? "" : prevState.errors[activeTab]?.priorTermPolicy,
                                lineOfCoverage: fieldName !== "Current Term Policy" && fieldName !== "Prior Term Policy"
                                    ? "" : prevState.errors[activeTab]?.lineOfCoverage,
                            }
                        }
                    };
                });
            }
        }

        // Reset input to allow re-upload of the same file
        const inputFile = this.fileInputRefs[fieldName]?.current;
        if (inputFile) {
            inputFile.value = "";
        }
    };

    handleRemarksChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { activeTab, remarks } = this.state;
        this.setState({
            remarks: {
                ...remarks,
                [activeTab]: event.target.value,
            },
        });
    };

    handleClientNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        const { activeTab, clientName } = this.state;

        this.setState({
            clientName: {
                ...clientName,
                [activeTab]: value,
            },
        });
    };

    handleMenuItemKeyDown = (e: React.KeyboardEvent, value: string) => {
        if (e.key === " ") {
            e.preventDefault();
            const fakeEvent = {
                target: { value }
            } as SelectChangeEvent<string>;
            this.handleCoverageChange(fakeEvent);
        }
    };

    handleCoverageChange = async (event: SelectChangeEvent<string>) => {
        const selectedCoverage = event?.target?.value;
        const { activeTab, errors } = this.state;
        this.setState((prevState) => ({
            selectedCoverage: {
                ...prevState.selectedCoverage,
                [activeTab]: selectedCoverage,
            },
            errors: {
                ...prevState.errors,
                [activeTab]: {
                    ...prevState.errors[activeTab],
                    lineOfCoverage: "",  // Clear only the lineOfCoverage error
                }
            },
        }))
    };

    handleUserSelectionChange(event: any) {
        const rawValue = event?.id;
        const value = Number(rawValue) || 0;
        const { activeTab } = this.state;
        this.setState((prevState) => ({
            selectedPrimaryUser: {
                ...prevState.selectedPrimaryUser,
                [activeTab]: value,
            },
            errors: {
                ...prevState.errors,
                [activeTab]: {
                    ...prevState.errors[activeTab],
                    primaryUser: "",
                }
            },
        }));
    }

    handleSecondaryUserSelectionChange(event: any) {
        const rawValue = event?.id;
        const value = Number(rawValue) || 0;
        const { activeTab } = this.state;
        this.setState((prevState) => ({
            selectedSecondaryUser: {
                ...prevState.selectedSecondaryUser,
                [activeTab]: value,
            },
            errors: {
                ...prevState.errors,
                [activeTab]: {
                    ...prevState.errors[activeTab],
                    secondaryUser: "",
                }
            },
        }));
    }

    handleChecklistChange = (event: SelectChangeEvent<string>) => {
        const { activeTab, selectedChecklist, errors } = this.state;
        this.setState({
            selectedChecklist: {
                ...selectedChecklist,
                [activeTab]: event.target.value,
            },
            errors: {
                ...errors,
                [activeTab]: {
                    ...errors[activeTab],
                    checklist: "", // Clear the error message once the field is changed
                }
            },
        });
    };

    handleFileRemove = (fieldName: string, fileIndex?: number) => {
        const { activeTab, uploadedFiles } = this.state;
        const existingFiles = uploadedFiles[activeTab]?.[fieldName];

        if (Array.isArray(existingFiles)) {
            if (fileIndex !== undefined && fileIndex >= 0 && fileIndex < existingFiles.length) {
                // Remove specific file
                const updatedFiles = [...existingFiles];
                updatedFiles.splice(fileIndex, 1);

                this.setState({
                    uploadedFiles: {
                        ...uploadedFiles,
                        [activeTab]: {
                            ...uploadedFiles[activeTab],
                            [fieldName]: updatedFiles.length ? updatedFiles : null,
                        },
                    },
                });
            }
        } else {
            // Remove all files
            this.setState({
                uploadedFiles: {
                    ...uploadedFiles,
                    [activeTab]: {
                        ...uploadedFiles[activeTab],
                        [fieldName]: null,
                    },
                },
            });
        }
        if (this.fileInputRefs[fieldName]?.current) {
            this.fileInputRefs[fieldName].current!.value = "";
        }
    };

    validateForm = () => {
        const { activeTab, selectedCoverage, selectedChecklist, uploadedFiles, showPrimaryUser, selectedPrimaryUser, selectedSecondaryUser } = this.state;
        let errors = { ...this.state.errors }; // Preserve existing errors for both tabs
        errors[activeTab] = {
            lineOfCoverage: "",
            checklist: "",
            currentTermPolicy: "",
            priorTermPolicy: "",
            duplicateFiles: "",
            sourceDoc: "",
            primaryUser: "",
            secondaryUser: ""
        };

        // Validate Line of Coverage
        if (!selectedCoverage[activeTab]) {
            this.setState({ isMandatory: true });
            errors[activeTab].lineOfCoverage = "Line of Coverage is mandatory*";
        }

        // Validate Select Checklist
        if (!selectedChecklist[activeTab]) {
            this.setState({ isMandatory: true });
            errors[activeTab].checklist = "Checklist is mandatory*";
        }

        // Validate Current Term Policy
        if (!uploadedFiles[activeTab]["Current Term Policy"]) {
            this.setState({ isMandatory: true });
            errors[activeTab].currentTermPolicy = "Current Term Policy is mandatory*";
        }

        // Validate Prior Term Policy
        if (activeTab != "MarketedRenewal") {
            if (!uploadedFiles[activeTab]["Prior Term Policy"]) {
                this.setState({ isMandatory: true });
                errors[activeTab].priorTermPolicy = "Prior Term Policy is mandatory*";
            }
        }

        if (selectedSecondaryUser[activeTab] && selectedPrimaryUser[activeTab] && selectedPrimaryUser[activeTab] === selectedSecondaryUser[activeTab] && showPrimaryUser) {
            alert("Please select different Primary and Secondary Users");
            return false;
        }

        // If there are errors, return false
        if (Object.values(errors[activeTab])?.some(error => error !== "")) {
            this.setState({ errors });
            return false;
        }

        // Check for Duplicate Files for all fieldNames
        const fieldNames = ["Current Term Policy", "Prior Term Policy", "Current Endorsement",
            "Prior Endorsement", "Proposal", "Acord Application", "Carrier Quote", "Binder", "Schedule"];
        const uploadedTab = uploadedFiles[activeTab];
        let alertFlag = false;
        if (uploadedTab) {
            const file = new Set();
            for (const field of fieldNames) {
                uploadedTab[field]?.forEach(fileObj => {
                    const fileExist = fileObj?.file?.name;
                    if (fileExist) {
                        const fileMatch = fileExist;
                        if (file.has(fileMatch)) {
                            alertFlag = true;
                        }
                    }
                    file.add(fileExist);
                })
            }
            if (alertFlag) {
                alert('Duplicate document uploaded. Please check the document and reupload');
                return false;
            }
        }

        // Check for allow only 4 source doc for upload validation
        const sourceFieldValidation = ["Proposal", "Acord Application", "Carrier Quote", "Binder", "Schedule"];
        if (activeTab == "MarketedRenewal") {
            const checkUploadCount = sourceFieldValidation.filter(
                (field) => (uploadedFiles[activeTab]?.[field]?.length ?? 0) > 0
            ).length;

            const ctpCount = uploadedFiles[activeTab]?.["Current Term Policy"]?.length ?? 0;
            const totalUploaded = (ctpCount > 0 ? 1 : 0) + checkUploadCount;

            const marshalBrokerMapping = this.state?.MarshalBrokerMapping || {};
            const maxSourceAllowed = marshalBrokerMapping?.SourceDocCount || 3;

            if (checkUploadCount > maxSourceAllowed) {
                alert(`Only upto ${maxSourceAllowed} Source Documents can be uploaded.`);
                return false;
            }
        }

        // if (uploadedFiles[activeTab]["Current Term Policy"] && uploadedFiles[activeTab]["Prior Term Policy"]) {
        //     const currentTermFile = uploadedFiles[activeTab]["Current Term Policy"];
        //     const priorTermFile = uploadedFiles[activeTab]["Prior Term Policy"];
        //     if (currentTermFile && priorTermFile && currentTermFile[0]?.file?.name === priorTermFile[0]?.file?.name) {
        //         alert('Duplicate document uploaded. The files for current term and prior term cannot be the same');
        //         return;
        //     }
        // }

        if (activeTab == "MarketedRenewal") {
            const requiredDocuments = ["Proposal", "Acord Application", "Carrier Quote", "Binder"];
            const isAnyFileUploaded = requiredDocuments?.some(doc => uploadedFiles[activeTab]?.[doc]);

            if (!isAnyFileUploaded) {
                alert("Please choose Proposal or ACORD Application or Carrier Quote or Binder");
                return false;
            }
        }

        return true;
    };

    handleReset = async () => {
        this.setState({
            jobId: "",
            JobId: "",
            successfullyUploadedFields: {},
            successfullyUploadedDocs: {},
            lockedFieldsMessage: "",
            selectedCoverage: {
                AutomaticRenewal: "",
                MarketedRenewal: ""
            },
            selectedChecklist: {
                AutomaticRenewal: "",
                MarketedRenewal: ""
            },
            uploadedFiles: {
                AutomaticRenewal: {},
                MarketedRenewal: {}
            },
            remarks: {
                AutomaticRenewal: "",
                MarketedRenewal: "",
            },
            clientName: {
                AutomaticRenewal: "",
                MarketedRenewal: ""
            },
            selectedPrimaryUser: {
                AutomaticRenewal: 0,
                MarketedRenewal: 0
            },
            selectedSecondaryUser: {
                AutomaticRenewal: 0,
                MarketedRenewal: 0
            },
            errors: {
                AutomaticRenewal: {
                    lineOfCoverage: "",
                    checklist: "",
                    currentTermPolicy: "",
                    priorTermPolicy: "",
                    duplicateFiles: "",
                    sourceDoc: "",
                    primaryUser: "",
                    secondaryUser: ""
                },
                MarketedRenewal: {
                    lineOfCoverage: "",
                    checklist: "",
                    currentTermPolicy: "",
                    priorTermPolicy: "",
                    duplicateFiles: "",
                    sourceDoc: "",
                    primaryUser: "",
                    secondaryUser: ""
                }
            },
        }, () => {
            // Reset file inputs manually
            Object.keys(this.fileInputRefs)?.forEach((key) => {
                if (this.fileInputRefs[key].current) {
                    this.fileInputRefs[key].current!.value = "";
                }
            });
        });
    };

    handleSubmit = async () => {
        if (this.validateForm()) {
            const {
                activeTab,
                selectedCoverage,
                selectedChecklist,
                remarks,
                clientName,
                uploadedFiles,
                jobId,
                JobId,
                successfullyUploadedDocs,
                Role_Id,
                showPrimaryUser,
                selectedPrimaryUser,
                selectedSecondaryUser,
            } = this.state;
            const { isMSUser, selectedBrokerId, selectedCSRUserId, selectedSecondaryCSRUserId } = this.props;
            // Clean up file names before upload — remove all dots (.) except the last one
            const cleanedUploadedFiles = JSON.parse(JSON.stringify(uploadedFiles));

            Object.keys(cleanedUploadedFiles).forEach((tabKey) => {
                const tabFiles = cleanedUploadedFiles[tabKey];
                if (!tabFiles) return;

                Object.keys(tabFiles).forEach((fieldName) => {
                    const fileArray = tabFiles[fieldName];
                    if (Array.isArray(fileArray)) {
                        tabFiles[fieldName] = fileArray.map(({ name, file, docType }) => {
                            const lastDotIndex = name.lastIndexOf(".");
                            let cleanedName = name;

                            if (lastDotIndex > 0) {
                                const nameWithoutExt = name.slice(0, lastDotIndex);
                                const extension = name.slice(lastDotIndex + 1);

                                // Remove all other dots from name part, keep only last one
                                const sanitizedName = nameWithoutExt.replace(/\./g, "");
                                cleanedName = `${sanitizedName}.${extension}`;
                            }

                            return { name: cleanedName, file, docType };
                        });
                    }
                });
            });

            // Use cleaned filenames for upload
            const filesToUpload = cleanedUploadedFiles[activeTab];

            const token = sessionStorage.getItem("token");
            this.setState({ loading: true });
            try {
                const Token = await expTokenProcessAndGenerate(token);
                const decodedToken = decodeJwt(token);
                let jobIdToUse = jobId;
                let jobIdValue = JobId;
                let createIdResponse = null;

                if (!jobIdToUse) {
                    // createIdResponse = await createIdForFileUploaded(
                    //     activeTab,
                    //     selectedCoverage,
                    //     selectedChecklist,
                    //     clientName,
                    //     remarks
                    // );
                    const brokerId = selectedBrokerId || decodedToken?.BrokerId;
                    const userId = selectedPrimaryUser[activeTab] || selectedCSRUserId;
                    const secondaryUserId = selectedSecondaryUser[activeTab] || selectedSecondaryCSRUserId;
                    createIdResponse = await createIdForFileUploaded(
                        {
                            JobTypeId: activeTab === "AutomaticRenewal" ? 1 : 2,
                            LobCode: selectedCoverage[activeTab],
                            MacroFile: selectedChecklist[activeTab],
                            ClientName: clientName[activeTab],
                            Remarks: remarks[activeTab],
                            MisUser: userId || secondaryUserId ? true : false,
                            brokerId: brokerId,
                            userId: userId,
                            secondaryUserId: secondaryUserId,
                            ComplianceFlag: this.props.complianceFlag ?? 0,
                        }
                    );
                    const responseData = createIdResponse?.data;

                    if (responseData?.status === "success") {
                        jobIdToUse = responseData?.data?.Id;
                        jobIdValue = responseData?.data?.JobId;

                        this.setState({
                            jobId: jobIdToUse,
                            JobId: jobIdValue,
                            snackbarOpen: true,
                            snackbarMessage: responseData?.message || "Job created successfully",
                            snackbarSeverity: "success"
                        });
                    } else {
                        this.setState({
                            snackbarOpen: true,
                            snackbarMessage: "Job creation failed",
                            snackbarSeverity: "error"
                        });
                    }
                }

                const getBrokerId = Number(jobIdValue?.slice(0, 4))
                const brokerFileSizeRestriction = await fetchBrokerFileUploadLImit(getBrokerId);
                const DEFAULT_FILE_SIZE_MB = 80;

                const maxFileSizeMB = brokerFileSizeRestriction && brokerFileSizeRestriction?.INT_FILE_SIZE
                    ? brokerFileSizeRestriction?.INT_FILE_SIZE
                    : DEFAULT_FILE_SIZE_MB;
                const maxFileSizeBytes = maxFileSizeMB * 1024 * 1024;

                const filesToUpload = uploadedFiles[activeTab];
                const uploadPromises = [];

                const newSuccessfullyUploadedDocs = { ...successfullyUploadedDocs };
                const previouslyUploadedFileNames: any = {};

                if (newSuccessfullyUploadedDocs?.[activeTab]) {
                    for (const field in newSuccessfullyUploadedDocs[activeTab]) {
                        previouslyUploadedFileNames[field] =
                            newSuccessfullyUploadedDocs[activeTab][field]?.map(
                                (item: any) => item?.fileName
                            ) || [];
                    }
                }

                const oversizedFiles: string[] = [];
                for (const key in filesToUpload) {
                    const uploadedFile = filesToUpload[key];
                    if (!uploadedFile) continue;

                    for (const { file } of uploadedFile) {
                        if (!file) continue;
                        if (file.size > maxFileSizeBytes) {
                            oversizedFiles.push(file.name);
                        }
                    }
                }

                if (oversizedFiles.length > 0) {
                    alert(
                        `Exceeds the allowed size limit of ${maxFileSizeMB} MB for this BrokerId:\n\n${oversizedFiles.join(
                            ", "
                        )}\n\nPlease remove them and try again.`
                    );
                    this.setState({ loading: false });
                    return;
                }

                if (filesToUpload) {
                    for (const key in filesToUpload) {
                        const uploadedFile = filesToUpload[key];
                        if (!uploadedFile) continue;

                        for (const { file, docType } of uploadedFile) {
                            if (!file) continue;

                            const alreadyUploadedFileNames = previouslyUploadedFileNames?.[key] || [];
                            const isAlreadyUploaded = alreadyUploadedFileNames?.includes(file?.name);

                            if (isAlreadyUploaded) {
                                console.log(`Skipping already uploaded docType ${docType} for field ${key}`);
                                continue;
                            }
                            const formData = new FormData();
                            formData.append("files", file);
                            formData.append("jobid", jobIdToUse?.toString());
                            formData.append("documenttype", docType.toString());

                            const uploadPromise = axios
                                .post(
                                    `${baseUrl}api/Upload/UploadPdfs?documenttype=${docType}&jobid=${jobIdToUse}`,
                                    formData,
                                    {
                                        headers: {
                                            Authorization: `Bearer ${Token}`,
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }
                                )
                                .then((response) => ({
                                    response,
                                    docType,
                                    key,
                                    fileName: file.name,
                                }))
                                .catch((error) => {
                                    const status = error?.response?.status || 500;
                                    const message = error?.response?.data?.detail || "Unknown error occurred";

                                    let userMessage;
                                    switch (status) {
                                        case 400:
                                            userMessage = "Invalid file type. Please upload a supported format.";
                                            break;
                                        case 404:
                                            userMessage = "Job ID not found. Please create a job before uploading.";
                                            break;
                                        case 415:
                                            userMessage = "File is corrupted or unreadable.";
                                            break;
                                        case 502:
                                            userMessage = "Upload failed due to S3 service issue. Try again later.";
                                            break;
                                        default:
                                            userMessage = `Upload failed: ${message}`;
                                    }

                                    this.setState({
                                        snackbarOpen: true,
                                        snackbarMessage: userMessage,
                                        snackbarSeverity: "error",
                                        loading: false,
                                    });
                                    return {
                                        response: null,
                                        docType,
                                        key,
                                        fileName: file.name,
                                        failed: true,
                                    };
                                });

                            uploadPromises.push(uploadPromise);
                        }
                    }
                    const uploadResults = await Promise.allSettled(uploadPromises);

                    // Separate tracking for corrupted & empty files
                    const corruptedDocTypes: any = [];
                    const emptyDocTypes: any = [];

                    const corruptedFilesMap: any = {};
                    const emptyFilesMap: any = {};

                    uploadResults.forEach((result: any) => {
                        if (result.status === "fulfilled") {
                            const { response, docType, key, fileName } = result.value;

                            if (response?.status === 200) {
                                // Successful upload
                                return;
                            } else {
                                // Unexpected success case but status !== 200
                                corruptedFilesMap[key] = corruptedFilesMap[key] || [];
                                corruptedFilesMap[key].push({ fileName, docType });
                            }
                        } else if (result.status === "rejected") {
                            // Handle rejected promise
                            const errorInfo = result.reason || {};
                            const { key, fileName, docType } = errorInfo;

                            corruptedFilesMap[key] = corruptedFilesMap[key] || [];
                            corruptedFilesMap[key].push({ fileName, docType });
                        }
                    });

                    // Re-fetch filesToUpload here to avoid stale keys issue ===
                    const latestFilesToUpload = this.state.uploadedFiles[activeTab];

                    const updatedSuccessfulFields: any = {};
                    const updatedSuccessfulDocs: any = {};

                    if (latestFilesToUpload && typeof latestFilesToUpload === "object") {
                        for (const key in latestFilesToUpload) {
                            const filesAry = latestFilesToUpload[key];
                            if (!Array.isArray(filesAry)) continue;

                            filesAry.forEach((doc) => {
                                const isCorrupted =
                                    corruptedFilesMap[key]?.some((f: any) => f.fileName === doc.file.name) || false;
                                const isEmpty =
                                    emptyFilesMap[key]?.some((f: any) => f.fileName === doc.file.name) || false;

                                // Lock only the successful files
                                if (!isCorrupted && !isEmpty) {
                                    updatedSuccessfulFields[key] = updatedSuccessfulFields[key] || {};
                                    updatedSuccessfulFields[key][doc.file.name] = true;

                                    updatedSuccessfulDocs[key] = [
                                        ...(updatedSuccessfulDocs[key] || []),
                                        {
                                            docType: Number(doc.docType),
                                            fileName: doc?.file.name,
                                        },
                                    ];
                                }
                            });
                        }
                    }

                    const lockedFieldsMessage = `The files are successfully uploaded and field is locked.`;

                    this.setState((prevState) => ({
                        successfullyUploadedFields: {
                            ...prevState.successfullyUploadedFields,
                            [activeTab]: {
                                ...prevState.successfullyUploadedFields[activeTab],
                                ...updatedSuccessfulFields,
                            },
                        },
                        successfullyUploadedDocs: {
                            ...prevState.successfullyUploadedDocs,
                            [activeTab]: {
                                ...prevState.successfullyUploadedDocs?.[activeTab],
                                ...updatedSuccessfulDocs,
                            },
                        },
                        lockedFieldsMessage,
                    }));

                    if (corruptedDocTypes.length > 0 || emptyDocTypes.length > 0) {
                        const corruptedFields = Object.keys(this.docTypeArray).filter((key) =>
                            corruptedDocTypes.includes(this.docTypeArray[key])
                        );
                        const emptyFields = Object.keys(this.docTypeArray).filter((key) =>
                            emptyDocTypes.includes(this.docTypeArray[key])
                        );

                        const messages: string[] = [];

                        // Add corrupted file names to message
                        if (corruptedFields.length > 0) {
                            const corruptedFileNames = Object.values(corruptedFilesMap)
                                .flat()
                                .map((f: any) => f.fileName);
                            messages.push(
                                `${corruptedFileNames.join(", ")} Error processing PDF file: Stream has ended unexpectedly`
                            );
                        }

                        // Add empty file names to message
                        if (emptyFields.length > 0) {
                            const emptyFileNames = Object.values(emptyFilesMap)
                                .flat()
                                .map((f: any) => f.fileName);
                            messages.push(`${emptyFileNames.join(", ")} File is empty or contains no text`);
                        }

                        this.setState({
                            corruptedFiles: {
                                ...this.state.corruptedFiles,
                                [activeTab]: corruptedFilesMap,
                            },
                            emptyFiles: {
                                ...this.state.emptyFiles,
                                [activeTab]: emptyFilesMap,
                            },
                            snackbarOpen: true,
                            snackbarMessage: messages.join(" "),
                        });

                        return;
                    }
                    if (uploadResults?.every(
                        (r) => r.status === "fulfilled" && r.value.response?.status === 200
                    )) {
                        try {
                            const jobIdResponse = await createJobidForAfterFileUpload(jobIdToUse);
                            const { basePath } = this.props;
                            if (jobIdResponse?.status === 200) {
                                const jobTypeId =
                                    createIdResponse?.data?.data?.JobTypeId === 1
                                        ? "Automatic Renewal"
                                        : "Marketed Renewal";

                                alert(`${jobTypeId} Files Uploaded Successfully for Job ID: ${jobIdValue}`);
                                await this.handleReset();

                                setTimeout(() => {
                                    if ([UserRole?.CSR, UserRole?.BrokerAdmin]?.includes(Role_Id)) {
                                        window.location.href = basePath + "/jobs/jobcsrlisting";
                                    } else {
                                        window.location.href = basePath + "/jobs/joblisting";
                                    }
                                }, 2000);
                            }
                        } catch (error) {
                            console.error("Error in creating job:", error);
                        }
                    }
                }
            } catch (error) {
                console.error("Error in jobId creation API calls:", error);
            } finally {
                this.setState({ loading: false });
            }
        }
    };

    handleDrop = (e: React.DragEvent<HTMLDivElement>, fieldName: string) => {
        e.preventDefault();
        let files = e.dataTransfer.files;
        //only single file for "Current Term Policy" and "Prior Term Policy"
        const isSingleFile = ["Current Term Policy", "Prior Term Policy"].includes(fieldName);
        if (isSingleFile && files.length > 1) {
            alert(`Only one file is allowed for the ${fieldName}.`);
            return;
        }
        const fileList = isSingleFile ? [files[0]] : Array.from(files);
        const event = {
            target: { files: fileList }
        } as unknown as React.ChangeEvent<HTMLInputElement>;

        this.handleFileUpload(event, fieldName);
    };

    showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    handleCloseConfirmDialog = () => {
        this.setState({ isMandatory: false, mandatoryMessage: "" });
    };

    renderFileUpload = (fieldName: string, label: string, isRequired: boolean = false) => {
        if (!this.fileInputRefs[fieldName]) {
            this.fileInputRefs[fieldName] = createRef();
        }
        const { activeTab, uploadedFiles, successfullyUploadedFields, lockedFieldsMessage } = this.state;

        const isMultiFile = ["Current Endorsement", "Prior Endorsement"].includes(fieldName);
        const files: UploadedFile[] = (uploadedFiles[activeTab]?.[fieldName] ?? []) as UploadedFile[];
        const fieldLocks = successfullyUploadedFields?.[activeTab]?.[fieldName] || {};
        const isDisabled = typeof fieldLocks === "object" && files.length > 0 && files.every(file => fieldLocks[file.file.name]);

        return (
            <fieldset style={{
                display: "flex",
                border: "1px solid #ddd", padding: "10px", borderRadius: "5px", minHeight: "70px",
                flexDirection: "column",
                gap: "10px",
            }}>
                <div
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => this.handleDrop(e, fieldName)}
                    onDragLeave={(e) => e.preventDefault()}
                    style={{
                        border: '2px dashed #ccc',
                        padding: '10px',
                        borderRadius: '5px',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        backgroundColor: isDisabled ? '#f9f9f9' : '#fafafa',
                    }}
                >
                    <Grid container spacing={1} alignItems="flex-start" flexWrap="wrap">
                        <Grid item lg={12} sm={6}>
                            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                {label} {isRequired && <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>}
                            </Typography>
                            {fieldName === "Prior Term Policy" && activeTab === "MarketedRenewal" && (
                                <Typography variant="caption" sx={{ fontSize: '9px', color: 'red' }}>
                                    <span style={{ display: 'inline-block' }}><strong> Note: </strong>ExdionPOD will only check for Forms & Endorsements listed on the prior term since you are uploading a marketed policy. If you would like coverages checked against the prior term, consider using the Automatic Renewal tab.</span>
                                </Typography>
                            )}
                        </Grid>

                        <Grid item lg={3} sm={6}>
                            <Button
                                variant="contained"
                                component="label"
                                size="small"
                                disabled={isDisabled}
                                sx={{ fontSize: '8px', color: 'black', border: isDisabled ? '1px solid lightgray' : '1px solid black', backgroundColor: 'lightgray' }}
                            >
                                <span>Choose File</span>
                                <input
                                    type="file"
                                    multiple={isMultiFile}
                                    hidden
                                    ref={this.fileInputRefs[fieldName]}
                                    onChange={(e) => this.handleFileUpload(e, fieldName)}
                                />
                            </Button>
                        </Grid>
                        <Grid item lg={9} sm={6} sx={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                            {files.length > 0 &&
                                files.map((file: UploadedFile, index: number) => (
                                    <div key={index} style={{ display: "flex", alignItems: "center", gap: "5px", flexWrap: "wrap", }}>
                                        <span style={{ fontSize: "10px" }}>{file.name}</span>
                                        <IconButton size="small" onClick={() => this.handleFileRemove(fieldName, index)} disabled={isDisabled}>
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </div>
                                ))
                            }
                        </Grid>
                        {/* Success message with green check icon */}
                        {isDisabled && lockedFieldsMessage && (
                            <Grid item lg={12}>
                                <div style={{
                                    color: 'green',
                                    fontSize: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                }}>
                                    <CheckCircleOutlineRoundedIcon sx={{ fontSize: '1rem' }} />
                                    <span>{lockedFieldsMessage}</span>
                                </div>
                            </Grid>
                        )}
                    </Grid>
                </div>
            </fieldset>
        );
    };

    renderExtraFileUploads() {
        const { uploadedFiles, activeTab, errors, successfullyUploadedFields, lockedFieldsMessage } = this.state;
        const docs = ["Proposal", "Acord Application", "Carrier Quote", "Binder", "Schedule"];

        return (
            <>
                <Typography variant="body2" sx={{ fontSize: '12px' }}>
                    Select Source Document <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>
                </Typography>

                <fieldset style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    border: "1px solid #ddd",
                    padding: "10px",
                    borderRadius: "5px",
                    minHeight: "120px",
                    overflow: "auto",
                    maxWidth: "100%",
                    marginTop: '10px'
                }}>

                    {docs.map((doc) => {
                        if (!this.fileInputRefs[doc]) {
                            this.fileInputRefs[doc] = createRef();
                        }

                        const isMultiple = doc === 'Schedule';
                        const files = (uploadedFiles[activeTab]?.[doc] ?? []) as UploadedFile[];
                        const fieldLocks = successfullyUploadedFields?.[activeTab]?.[doc] || {};
                        const isDisabled = typeof fieldLocks === "object" && files?.length > 0 && files?.every(file => fieldLocks[file.file.name]);

                        // Drag-and-drop handlers
                        const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => e.preventDefault();
                        const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
                            e.preventDefault();
                            if (isDisabled) return;
                            const droppedFiles = e.dataTransfer.files;
                            if (!isMultiple && droppedFiles.length > 1) {
                                alert(`Only one file is allowed for the ${doc}.`);
                                return;
                            }
                            const fileList = isMultiple ? Array.from(droppedFiles) : [droppedFiles[0]];
                            const event = {
                                target: { files: fileList }
                            } as unknown as React.ChangeEvent<HTMLInputElement>;
                            this.handleFileUpload(event, doc);
                        };

                        return (
                            <div
                                key={doc}
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                onDragLeave={(e) => e.preventDefault()}
                                style={{
                                    border: '2px dashed #ccc',
                                    borderRadius: '5px',
                                    padding: '20px',
                                    marginBottom: '10px',
                                    backgroundColor: isDisabled ? '#f9f9f9' : '#fafafa',
                                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <Grid container spacing={1} alignItems="flex-start">
                                    <Grid item lg={3.5} sm={6}>
                                        <Typography variant="body2" sx={{ fontSize: '12px' }}>{doc}</Typography>
                                    </Grid>
                                    <Grid item lg={2.5} sm={6}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            size="small"
                                            disabled={isDisabled}
                                            sx={{
                                                minWidth: '20px',
                                                height: '20px',
                                                fontSize: '8px',
                                                padding: '0.5',
                                                color: 'black',
                                                border: '1px solid black',
                                                backgroundColor: 'lightgray',
                                            }}
                                        >
                                            Choose File
                                            <input
                                                type="file"
                                                multiple={isMultiple}
                                                hidden
                                                ref={this.fileInputRefs[doc]}
                                                onChange={(e) => this.handleFileUpload(e, doc)}
                                            />
                                        </Button>

                                    </Grid>
                                    <Grid item lg={6} sm={6} sx={{ display: "flex", flexWrap: "wrap", gap: "5px", overflow: "auto" }}>
                                        {Array.isArray(files) && files.length > 0 && (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: "5px", maxWidth: "100%" }}>
                                                {files.map((fileObj, index) => (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        gap: "5px",
                                                        alignItems: "center",
                                                        flexWrap: "wrap",
                                                        maxWidth: "100%",
                                                        wordBreak: "break-word",
                                                    }}>
                                                        <span style={{
                                                            fontSize: "10px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                        }}>
                                                            {fileObj?.file?.name}
                                                        </span>
                                                        <IconButton size="small" onClick={() => this.handleFileRemove(doc, index)} disabled={isDisabled}>
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </Grid>
                                    {/* Success message with green check icon */}
                                    {isDisabled && lockedFieldsMessage && (
                                        <Grid item lg={12}>
                                            <div style={{
                                                color: 'green',
                                                fontSize: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '5px',
                                            }}>
                                                <CheckCircleOutlineRoundedIcon sx={{ fontSize: '1rem' }} />
                                                <span>{lockedFieldsMessage}</span>
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </div>
                        );
                    })}
                    {errors[activeTab]?.sourceDoc && (
                        <span style={{ color: "red", fontSize: 'smaller' }}>{errors[activeTab]?.sourceDoc}</span>
                    )}
                </fieldset>
            </>
        );
    }


    render() {
        const { activeTab, selectedCoverage, selectedChecklist, remarks, clientName, errors, snackbarOpen, snackbarMessage, snackbarSeverity, loading, lobCodes, isMandatory, checklistTypes, csrs, showPrimaryUser, selectedPrimaryUser, selectedSecondaryUser } = this.state;
        const { displaysidebar } = this.props;
        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: -60,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable1 displaysidebar={displaysidebar}>
                    <div style={{ padding: "0px" }}>
                        <Tabs
                            value={activeTab}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            sx={{ minHeight: '22px' }}
                        >
                            <Tab
                                label="Automatic Renewal"
                                value="AutomaticRenewal"
                                sx={{ fontSize: '10px', minHeight: '22px', padding: '2px 8px' }}
                            />
                            <Tab
                                label="Marketed Renewal"
                                value="MarketedRenewal"
                                sx={{ fontSize: '10px', minHeight: '22px', padding: '2px 8px' }}
                            />
                        </Tabs>

                        <>

                            <div
                                style={{
                                    height: '80vh',
                                    overflowY: 'auto',
                                    paddingRight: '8px',
                                }}
                            >
                                <Grid container spacing={1} sx={{ display: 'flex', flexDirection: { xs: 'column', lg: 'row' }, marginTop: 0.5 }}>
                                    {/* Left Column */}
                                    <Grid item lg={displaysidebar ? 4.6 : 5.3} sm={12}>
                                        {/* Primary User */}
                                        {showPrimaryUser && <Grid item lg={12} sm={12} marginTop={1}>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                                Primary User
                                            </Typography>
                                            {/* <Select
                                                id="primaryUser"
                                                value={selectedPrimaryUser[activeTab]}
                                                onChange={this.handleUserSelectionChange.bind(this)}
                                                displayEmpty
                                                fullWidth
                                                sx={{
                                                    height: '30px',
                                                    '& .MuiOutlinedInput-input': { fontSize: '12px' },
                                                }}
                                            >
                                                {csrs?.map((item, index) => (
                                                    <MenuItem key={index} value={item.ID} sx={{ fontSize: '12px' }} onKeyDown={(e) => {
                                                        if (e.key === " ") {
                                                            e.preventDefault();
                                                            (e.target as HTMLElement).click(); // S
                                                        }
                                                    }}>{item.vchEmail}</MenuItem>
                                                ))}
                                            </Select> */}
                                            <Autocomplete
                                                options={csrs.map((b) => ({ label: b.vchEmail, id: b.ID }))}
                                                size="small"
                                                getOptionLabel={(option) => option?.label || ''}
                                                value={csrs.filter((e: any) => e.ID === selectedPrimaryUser[activeTab]).map((e: any) => ({ label: e.vchEmail, id: e.ID }))[0] || null}
                                                onChange={(_event, newValue) => this.handleUserSelectionChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        placeholder="Select Broker..."
                                                        size="medium"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: { height: 25, fontSize: "11px" }
                                                        }}
                                                    />
                                                )}
                                                fullWidth
                                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                            />
                                            {errors[activeTab]?.primaryUser && (
                                                <span style={{ color: 'red', fontSize: 'smaller' }}>
                                                    {errors[activeTab]?.primaryUser}
                                                </span>
                                            )}
                                        </Grid>}
                                        {/* Line of Coverage */}
                                        <Grid item lg={12} sm={12} marginTop={1}>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                                Line of Coverage <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>
                                            </Typography>
                                            <Select
                                                id="coverage"
                                                value={selectedCoverage[activeTab]}
                                                onChange={this.handleCoverageChange}
                                                displayEmpty
                                                fullWidth
                                                sx={{
                                                    height: '30px',
                                                    '& .MuiOutlinedInput-input': { fontSize: '12px' },
                                                }}
                                            >
                                                {lobCodes?.map((item, index) => (
                                                    <MenuItem key={index} value={item.Lob_Code} sx={{ fontSize: '12px' }} onKeyDown={(e) => {
                                                        if (e.key === " ") {
                                                            e.preventDefault();
                                                            (e.target as HTMLElement).click(); // S
                                                        }
                                                    }}>{item.Lob_Name}</MenuItem>
                                                ))}
                                            </Select>
                                            {errors[activeTab]?.lineOfCoverage && (
                                                <span style={{ color: 'red', fontSize: 'smaller' }}>
                                                    {errors[activeTab]?.lineOfCoverage}
                                                </span>
                                            )}
                                        </Grid>

                                        {/* Remarks */}
                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>Remarks</Typography>
                                            <input
                                                type="text"
                                                value={remarks[activeTab]}
                                                onChange={this.handleRemarksChange}
                                                placeholder="Remarks"
                                                maxLength={150}
                                                style={{
                                                    width: '100%',
                                                    height: '30px',
                                                    fontSize: '12px',
                                                    padding: '5px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    outline: 'none',
                                                }}
                                            />
                                            <Typography variant="caption" sx={{ fontSize: '10px', color: 'gray' }}>
                                                Maximum {remarks[activeTab]?.length || 0}/150 Characters
                                            </Typography>
                                        </Grid>

                                        {/* File Uploads */}
                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            {this.renderFileUpload("Current Term Policy", "Current Term Policy", true)}
                                            {errors[activeTab]?.currentTermPolicy && (
                                                <span style={{ color: 'red', fontSize: 'smaller' }}>
                                                    {errors[activeTab]?.currentTermPolicy}
                                                </span>
                                            )}
                                        </Grid>

                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            {this.renderFileUpload("Current Endorsement", "Endorsement", false)}
                                        </Grid>

                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            {activeTab === "MarketedRenewal" && this.renderExtraFileUploads()}
                                        </Grid>
                                    </Grid>

                                    {/* Right Column */}
                                    <Grid item lg={displaysidebar ? 4.6 : 5.3} sm={12}>
                                        {/* Secondary User */}
                                        {showPrimaryUser && <Grid item lg={12} sm={12} marginTop={1}>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                                Secondary User
                                            </Typography>
                                            <Autocomplete
                                                options={csrs.map((b) => ({ label: b.vchEmail, id: b.ID }))}
                                                size="small"
                                                getOptionLabel={(option) => option?.label || ''}
                                                value={csrs.filter((e: any) => e.ID === selectedSecondaryUser[activeTab]).map((e: any) => ({ label: e.vchEmail, id: e.ID }))[0] || null}
                                                onChange={(_event, newValue) => this.handleSecondaryUserSelectionChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        placeholder="Select Broker..."
                                                        size="medium"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            style: { height: 25, fontSize: "11px" }
                                                        }}
                                                    />
                                                )}
                                                fullWidth
                                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                                            />
                                            {errors[activeTab]?.secondaryUser && (
                                                <span style={{ color: 'red', fontSize: 'smaller' }}>
                                                    {errors[activeTab]?.secondaryUser}
                                                </span>
                                            )}
                                        </Grid>}
                                        {/* Checklist */}
                                        <Grid item lg={12} sm={12} marginTop={1}>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>
                                                Select Checklist <span style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>*</span>
                                            </Typography>
                                            <Select
                                                id="checklist"
                                                value={selectedChecklist[activeTab]}
                                                onChange={this.handleChecklistChange}
                                                displayEmpty
                                                fullWidth
                                                sx={{
                                                    height: '30px',
                                                    '& .MuiOutlinedInput-input': { fontSize: '12px' },
                                                }}
                                            >
                                                {checklistTypes?.map((item) => (
                                                    <MenuItem key={item.ID} value={item.VCH_CHECKLIST} sx={{ fontSize: '12px' }}>
                                                        {item.VCH_CHECKLIST}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {errors[activeTab]?.checklist && (
                                                <span style={{ color: 'red', fontSize: 'smaller' }}>
                                                    {errors[activeTab]?.checklist}
                                                </span>
                                            )}
                                        </Grid>

                                        {/* Client Name */}
                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            <Typography variant="body2" sx={{ fontSize: '12px' }}>Client Name</Typography>
                                            <input
                                                type="text"
                                                value={clientName[activeTab]}
                                                onChange={this.handleClientNameChange}
                                                placeholder="Client Name"
                                                maxLength={150}
                                                style={{
                                                    width: '100%',
                                                    height: '30px',
                                                    fontSize: '12px',
                                                    padding: '5px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    outline: 'none',
                                                }}
                                            />
                                            <Typography variant="caption" sx={{ fontSize: '10px', color: 'gray' }}>
                                                Maximum {clientName[activeTab]?.length || 0}/150 Characters
                                            </Typography>
                                        </Grid>

                                        {/* File Uploads */}
                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            {this.renderFileUpload("Prior Term Policy", "Prior Term Policy", activeTab === "MarketedRenewal" ? false : true)}
                                            {errors[activeTab]?.priorTermPolicy && (
                                                <span style={{ color: 'red', fontSize: 'smaller' }}>
                                                    {errors[activeTab]?.priorTermPolicy}
                                                </span>
                                            )}
                                        </Grid>

                                        <Grid item lg={12} sm={12} marginTop={0.5}>
                                            {this.renderFileUpload("Prior Endorsement", "Endorsement", false)}
                                        </Grid>

                                        <Grid item lg={12} sm={12} marginTop={2}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        sx={{ fontSize: '10px', backgroundColor: '#501e75' }}
                                                        onClick={this.handleSubmit}
                                                    >
                                                        Generate Checklist
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        sx={{ fontSize: '10px', backgroundColor: '#501e75' }}
                                                        onClick={this.handleReset}
                                                    >
                                                        Reset
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </>
                    </div>

                    {/* Confirmation Dialog For Mandatory Field*/}
                    <Dialog open={isMandatory} onClose={this.handleCloseConfirmDialog}>
                        <DialogContent sx={{
                            width: '370px',
                            padding: '20px 25px',
                            paddingTop: '10px',
                            paddingBottom: '15px',
                            textAlign: 'center',
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    mb: 2,
                                }}
                            >
                                <Box
                                    sx={{
                                        backgroundColor: '#FEE2E2',
                                        borderRadius: '50%',
                                        width: 60,
                                        height: 60,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <span style={{ color: '#B91C1C', fontSize: 50, marginTop: '15px' }}> * </span>
                                </Box>
                            </Box>
                            <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.25rem', p: 0 }}>
                                ⚠️Warning
                            </DialogTitle>
                            <DialogContentText sx={{ textAlign: 'center', fontWeight: 'bold', mt: 1, mb: 3, color: 'rgba(0, 0, 0, 0.7)' }}>
                                {this.state.mandatoryMessage || "Mandatory field is not selected!"}
                            </DialogContentText>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, height: '30px' }}>
                                <Button
                                    onClick={this.handleCloseConfirmDialog}
                                    sx={{
                                        color: '#007bff',
                                        borderColor: '#007bff',
                                        border: '0.5px solid #53494987',
                                        px: 4,
                                        borderRadius: '6px',
                                        '&:hover': {
                                            borderColor: '#0056b3',
                                            color: '#0056b3',
                                        },
                                    }}
                                >
                                    Close
                                </Button>
                            </Box>
                        </DialogContent>
                    </Dialog>

                    <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={2500}
                        onClose={this.handleCloseSnackbar}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
                            {snackbarMessage}
                        </Alert>
                    </Snackbar>

                </GridTable1>
            </>
        );
    }
}

export default RenewalForm;
